module.exports = __webpack_public_path__ + "img/tutorial-0.0c9acd8c.jpg";